// F-MOTOR-RESERVAS.3.1.5 — Badge visual da origem da reserva.
// Valores válidos: admin | site | whatsapp | orcamento
const ORIGEM_MAP = {
  admin: {
    bg: "bg-stone-100",
    text: "text-stone-700",
    dot: "bg-stone-500",
    label: "Admin",
  },
  site: {
    bg: "bg-[#E7F0FA]",
    text: "text-[#083A6B]",
    dot: "bg-[#083A6B]",
    label: "Site",
  },
  whatsapp: {
    bg: "bg-[#DFF5E6]",
    text: "text-[#1B6B3A]",
    dot: "bg-[#25D366]",
    label: "WhatsApp",
  },
  orcamento: {
    bg: "bg-[#FDF3E3]",
    text: "text-[#8B6A1F]",
    dot: "bg-[#D4A652]",
    label: "Orçamento",
  },
};

export function OrigemPill({ origem, testid }) {
  const key = origem || "admin";
  const s =
    ORIGEM_MAP[key] || {
      bg: "bg-stone-100",
      text: "text-stone-600",
      dot: "bg-stone-400",
      label: key,
    };
  return (
    <span
      data-testid={testid || `origem-pill-${key}`}
      className={`inline-flex items-center gap-1 rounded-full font-medium px-2 py-0.5 text-[10px] uppercase tracking-widest ${s.bg} ${s.text}`}
    >
      <span className={`w-1 h-1 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}

export const ORIGEM_LABELS = {
  admin: "Admin",
  site: "Site",
  whatsapp: "WhatsApp",
  orcamento: "Orçamento",
};
